interface WhatsAppButtonProps {
  onWhatsAppClick: () => void;
}

export default function WhatsAppButton({ onWhatsAppClick }: WhatsAppButtonProps) {
  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button 
        onClick={onWhatsAppClick}
        className="bg-green-500 hover:bg-green-600 text-white w-12 h-12 rounded-full shadow-2xl flex items-center justify-center transition-all transform hover:scale-110 animate-pulse cursor-pointer" 
        title="Falar com DJ Jean"
      >
        <i className="ri-whatsapp-line text-lg"></i>
      </button>
    </div>
  );
}